export const avisos = [
  {
    titulo: "COMUNICADO IMPORTANTE",
    mensagem: (
      <p>
        Prezado(a) Cliente, Em atendimento aos Ajustes SINIEF 11 e 12/2025,
        informamos que,{" "}
        <span>
          a partir de 04/05/2026, não será mais permitida a emissão de NFC-e
          para CNPJs.
        </span>
        <br />
        <br />
        As operações passarão a utilizar NF-e com impressão do{" "}
        <span>DANFE Simplificado Varejo,</span> conforme exigência legal.
        <br />
        <br />
        Para o correto funcionamento, será necessário utilizar, no mínimo, a
        seguinte versão do sistema: <span>PDV: versão 232 ou superior.</span>
        <br />
        <br />
        <span>Atenção:</span> Realize a atualização do sistema antes desta data
        para evitar problemas na emissão fiscal.
        <br />
        <br />
        <span>
          Nossa equipe de suporte está disponível para auxiliar na adequação.
        </span>
        <br />
        <br />
        <span style={{ color: "red" }}>
          Clientes Waybe (Soluções Web) recebem atualizações automáticas, sem
          necessidade de intervenção.
        </span>
      </p>
    ),
    faleConosco: true,
    ativo: false,
  },
];
